import { BatterySyncIcon } from './BatterySyncIcon';

/**
 * author: Michael Irigoyen
 * id A78E1E92-F129-4050-AA6F-B308D171A2DC
 * name battery-sync
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/battery-sync.svg
 * tags
 * - Battery 
 */
export const BatteryRecycleIcon = BatterySyncIcon;
export default BatteryRecycleIcon